import { render, staticRenderFns } from "./DeleteRoleMessage.vue?vue&type=template&id=3ea653f7&"
import script from "./DeleteRoleMessage.vue?vue&type=script&lang=js&"
export * from "./DeleteRoleMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports